















































































































import { IClient } from "@/models/clients";
import { ILead } from "@/models/leads";
import { IUser } from "@/models/users";
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  components: {
    "profile-avatar": () =>
      import("@/components/app/global/profileAvatar/profileAvatar.vue"),
    "location-map": () =>
      import("@/components/app/global/locationMap/locationMap.vue")
  },
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class ProfileCard extends Vue {
  // Props
  @Prop({ default: true })
  public showMap!: boolean;

  @Prop({ default: "client" })
  public type!: "client" | "lead" | "user";

  @Prop({ default: null })
  public objectId!: IClient["id"] | ILead["id"] | IUser["id"];

  @Prop({ default: "" })
  public name!: string;

  @Prop({ default: "" })
  public email!: string;

  @Prop({ default: "" })
  public imageSrc!: string;

  @Prop({ default: false })
  public isGuest!: boolean;

  @Prop({ default: "" })
  public dateCreated!: string;

  @Prop({ default: true })
  public hasLogin!: boolean;

  @Prop({ default: "" })
  public lastLogin!: string;

  @Prop({ default: false })
  public cardless!: boolean;

  @Prop({ default: false })
  public hideLogin!: boolean;

  @Prop({ default: "" })
  public brandName!: string;

  @Prop({ default: true })
  public hasImage!: boolean;

  @Prop({ default: null })
  public locationTown!: string;

  @Prop({ default: null })
  public locationCountryCode!: string;

  @Prop({ default: null })
  public referrer!: IClient;

  // Data
  public isMultibrand!: boolean;

  // Computed

  public get isLocationAvailable() {
    return (
      !this.$_.isNil(this.locationTown) &&
      !this.$_.isNil(this.locationCountryCode)
    );
  }

  public get createLocation() {
    if (this.$_.isNil(this.locationCountryCode)) {
      return this.locationTown;
    } else {
      if (this.$_.isNil(this.locationTown)) {
        return this.locationCountryCode;
      } else {
        return `${this.locationTown}+${this.locationCountryCode}`;
      }
    }
  }
}
